<span *ngIf="isInCurrentStock" class="stockmessage stockmessage-code-1">
  {{ 'stock.in-stock' | translate: { quantity: quantity } }}
</span>

<span *ngIf="isInFutureStock && !isCompactLayout" class="stockmessage stockmessage-code-2">
  {{ 'stock.future-stock' | translate: { quantity: quantity } }}<br />
  <span class="weeknr">{{ 'stock.code-2' | translate: { week: week } }}</span>
</span>

<span *ngIf="isInFutureStock && isCompactLayout" class="stockmessage stockmessage-code-2">
  {{ 'stock.future-stock-compact' | translate: { quantity: quantity, week: week } }}<br />
</span>

<span *ngIf="isOutOfStock" class="stockmessage stockmessage-code-4">
  {{ 'stock.out-of-stock' | translate }}
</span>
